// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__19Qpx","fileBtn":"File_fileBtn__2i3RF","closeBtn":"File_closeBtn__2H1Py","fileSelected":"File_fileSelected__u97Tl","disabled":"File_disabled__2Ntdu"};